module.exports = __webpack_public_path__ + "img/d-auto-en.c6f6cff7.png";